"use strict";

var _objectWithoutProperties = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connection = exports.isArangoConnection = void 0;

var querystring_1 = require("querystring");

var x3_linkedlist_1 = require("x3-linkedlist");

var error_1 = require("./error");

var btoa_1 = require("./lib/btoa");

var normalizeUrl_1 = require("./lib/normalizeUrl");

var request_1 = require("./lib/request");

var MIME_JSON = /\/(json|javascript)(\W|$)/;
var LEADER_ENDPOINT_HEADER = "x-arango-endpoint";

function clean(obj) {
  var result = {};

  for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var value = obj[key];
    if (value === undefined) continue;
    result[key] = value;
  }

  return result;
}

function isBearerAuth(auth) {
  return auth.hasOwnProperty("token");
}
/**
 * @internal
 * @hidden
 */


function generateStackTrace() {
  var err = new Error();

  if (!err.stack) {
    try {
      throw err;
    } catch (e) {
      err = e;
    }
  }

  return err;
}
/**
 * Indicates whether the given value represents a {@link Connection}.
 *
 * @param connection - A value that might be a connection.
 *
 * @internal
 * @hidden
 */


function isArangoConnection(connection) {
  return Boolean(connection && connection.isArangoConnection);
}

exports.isArangoConnection = isArangoConnection;
/**
 * Represents a connection pool shared by one or more databases.
 *
 * @internal
 * @hidden
 */

var Connection = /*#__PURE__*/function () {
  /**
   * @internal
   *
   * Creates a new `Connection` instance.
   *
   * @param config - An object with configuration options.
   *
   * @hidden
   */
  function Connection() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Connection);

    var _a, _b;

    this._activeTasks = 0;
    this._arangoVersion = 30400;
    this._queue = new x3_linkedlist_1.LinkedList();
    this._databases = new Map();
    this._hosts = [];
    this._urls = [];
    this._transactionId = null;
    var URLS = config.url ? Array.isArray(config.url) ? config.url : [config.url] : ["http://localhost:8529"];
    var MAX_SOCKETS = 3 * (config.loadBalancingStrategy === "ROUND_ROBIN" ? URLS.length : 1);

    if (config.arangoVersion !== undefined) {
      this._arangoVersion = config.arangoVersion;
    }

    this._agent = config.agent;
    this._agentOptions = request_1.isBrowser ? _objectSpread({
      maxSockets: MAX_SOCKETS
    }, config.agentOptions) : _objectSpread({
      maxSockets: MAX_SOCKETS,
      keepAlive: true,
      keepAliveMsecs: 1000,
      scheduling: "lifo"
    }, config.agentOptions);
    this._maxTasks = this._agentOptions.maxSockets;
    this._headers = _objectSpread({}, config.headers);
    this._loadBalancingStrategy = (_a = config.loadBalancingStrategy) !== null && _a !== void 0 ? _a : "NONE";
    this._useFailOver = this._loadBalancingStrategy !== "ROUND_ROBIN";
    this._precaptureStackTraces = Boolean(config.precaptureStackTraces);

    if (config.maxRetries === false) {
      this._shouldRetry = false;
      this._maxRetries = 0;
    } else {
      this._shouldRetry = true;
      this._maxRetries = (_b = config.maxRetries) !== null && _b !== void 0 ? _b : 0;
    }

    this.addToHostList(URLS);

    if (config.auth) {
      if (isBearerAuth(config.auth)) {
        this.setBearerAuth(config.auth);
      } else {
        this.setBasicAuth(config.auth);
      }
    }

    if (this._loadBalancingStrategy === "ONE_RANDOM") {
      this._activeHost = Math.floor(Math.random() * this._hosts.length);
      this._activeDirtyHost = Math.floor(Math.random() * this._hosts.length);
    } else {
      this._activeHost = 0;
      this._activeDirtyHost = 0;
    }
  }
  /**
   * @internal
   *
   * Indicates that this object represents an ArangoDB connection.
   */


  _createClass(Connection, [{
    key: "isArangoConnection",
    get: function get() {
      return true;
    }
  }, {
    key: "_runQueue",
    value: function _runQueue() {
      var _this = this;

      if (!this._queue.length || this._activeTasks >= this._maxTasks) return;

      var task = this._queue.shift();

      var host = this._activeHost;

      if (task.host !== undefined) {
        host = task.host;
      } else if (task.allowDirtyRead) {
        host = this._activeDirtyHost;
        this._activeDirtyHost = (this._activeDirtyHost + 1) % this._hosts.length;
        task.options.headers["x-arango-allow-dirty-read"] = "true";
      } else if (this._loadBalancingStrategy === "ROUND_ROBIN") {
        this._activeHost = (this._activeHost + 1) % this._hosts.length;
      }

      this._activeTasks += 1;

      var callback = function callback(err, res) {
        _this._activeTasks -= 1;

        if (err) {
          if (!task.allowDirtyRead && _this._hosts.length > 1 && _this._activeHost === host && _this._useFailOver) {
            _this._activeHost = (_this._activeHost + 1) % _this._hosts.length;
          }

          if (!task.host && _this._shouldRetry && task.retries < (_this._maxRetries || _this._hosts.length - 1) && error_1.isSystemError(err) && err.syscall === "connect" && err.code === "ECONNREFUSED") {
            task.retries += 1;

            _this._queue.push(task);
          } else {
            if (task.stack) {
              err.stack += task.stack();
            }

            task.reject(err);
          }
        } else {
          var response = res;

          if (response.statusCode === 503 && response.headers[LEADER_ENDPOINT_HEADER]) {
            var url = response.headers[LEADER_ENDPOINT_HEADER];

            var _this$addToHostList = _this.addToHostList(url),
                _this$addToHostList2 = _slicedToArray(_this$addToHostList, 1),
                index = _this$addToHostList2[0];

            task.host = index;

            if (_this._activeHost === host) {
              _this._activeHost = index;
            }

            _this._queue.push(task);
          } else {
            response.arangojsHostId = host;
            task.resolve(response);
          }
        }

        _this._runQueue();
      };

      try {
        this._hosts[host](task.options, callback);
      } catch (e) {
        callback(e);
      }
    }
  }, {
    key: "_buildUrl",
    value: function _buildUrl(_ref) {
      var basePath = _ref.basePath,
          path = _ref.path,
          qs = _ref.qs;
      var pathname = "".concat(basePath || "").concat(path || "");
      var search;

      if (qs) {
        if (typeof qs === "string") search = "?".concat(qs);else search = "?".concat(querystring_1.stringify(clean(qs)));
      }

      return search ? {
        pathname: pathname,
        search: search
      } : {
        pathname: pathname
      };
    }
  }, {
    key: "setBearerAuth",
    value: function setBearerAuth(auth) {
      this.setHeader("authorization", "Bearer ".concat(auth.token));
    }
  }, {
    key: "setBasicAuth",
    value: function setBasicAuth(auth) {
      this.setHeader("authorization", "Basic ".concat(btoa_1.btoa("".concat(auth.username, ":").concat(auth.password))));
    }
  }, {
    key: "database",
    value: function database(databaseName, _database) {
      if (_database === null) {
        this._databases.delete(databaseName);

        return undefined;
      }

      if (!_database) {
        return this._databases.get(databaseName);
      }

      this._databases.set(databaseName, _database);

      return _database;
    }
    /**
     * @internal
     *
     * Adds the given URL or URLs to the host list.
     *
     * See {@link Connection.acquireHostList}.
     *
     * @param urls - URL or URLs to add.
     */

  }, {
    key: "addToHostList",
    value: function addToHostList(urls) {
      var _this2 = this,
          _this$_urls,
          _this$_hosts;

      var cleanUrls = (Array.isArray(urls) ? urls : [urls]).map(function (url) {
        return normalizeUrl_1.normalizeUrl(url);
      });
      var newUrls = cleanUrls.filter(function (url) {
        return _this2._urls.indexOf(url) === -1;
      });

      (_this$_urls = this._urls).push.apply(_this$_urls, _toConsumableArray(newUrls));

      (_this$_hosts = this._hosts).push.apply(_this$_hosts, _toConsumableArray(newUrls.map(function (url) {
        return request_1.createRequest(url, _this2._agentOptions, _this2._agent);
      })));

      return cleanUrls.map(function (url) {
        return _this2._urls.indexOf(url);
      });
    }
    /**
     * @internal
     *
     * Sets the connection's active `transactionId`.
     *
     * While set, all requests will use this ID, ensuring the requests are executed
     * within the transaction if possible. Setting the ID manually may cause
     * unexpected behavior.
     *
     * See also {@link Connection.clearTransactionId}.
     *
     * @param transactionId - ID of the active transaction.
     */

  }, {
    key: "setTransactionId",
    value: function setTransactionId(transactionId) {
      this._transactionId = transactionId;
    }
    /**
     * @internal
     *
     * Clears the connection's active `transactionId`.
     */

  }, {
    key: "clearTransactionId",
    value: function clearTransactionId() {
      this._transactionId = null;
    }
    /**
     * @internal
     *
     * Sets the header `headerName` with the given `value` or clears the header if
     * `value` is `null`.
     *
     * @param headerName - Name of the header to set.
     * @param value - Value of the header.
     */

  }, {
    key: "setHeader",
    value: function setHeader(headerName, value) {
      if (value === null) {
        delete this._headers[headerName];
      } else {
        this._headers[headerName] = value;
      }
    }
    /**
     * @internal
     *
     * Closes all open connections.
     *
     * See {@link Database.close}.
     */

  }, {
    key: "close",
    value: function close() {
      var _iterator = _createForOfIteratorHelper(this._hosts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var host = _step.value;
          if (host.close) host.close();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * @internal
     *
     * Waits for propagation.
     *
     * See {@link Database.waitForPropagation}.
     *
     * @param request - Request to perform against each coordinator.
     * @param timeout - Maximum number of milliseconds to wait for propagation.
     */

  }, {
    key: "waitForPropagation",
    value: function () {
      var _waitForPropagation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var timeout,
            numHosts,
            propagated,
            started,
            host,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                timeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : Infinity;
                numHosts = this._hosts.length;
                propagated = [];
                started = Date.now();
                host = 0;

              case 5:
                if (!true) {
                  _context.next = 24;
                  break;
                }

                if (!(propagated.length === numHosts)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                while (propagated.includes(host)) {
                  host = (host + 1) % numHosts;
                }

                _context.prev = 9;
                _context.next = 12;
                return this.request(_objectSpread(_objectSpread({}, request), {}, {
                  host: host
                }));

              case 12:
                _context.next = 21;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](9);

                if (!(started + timeout < Date.now())) {
                  _context.next = 18;
                  break;
                }

                throw _context.t0;

              case 18:
                _context.next = 20;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 20:
                return _context.abrupt("continue", 5);

              case 21:
                if (!propagated.includes(host)) {
                  propagated.push(host);
                }

                _context.next = 5;
                break;

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 14]]);
      }));

      function waitForPropagation(_x) {
        return _waitForPropagation.apply(this, arguments);
      }

      return waitForPropagation;
    }()
    /**
     * @internal
     *
     * Performs a request using the arangojs connection pool.
     */

  }, {
    key: "request",
    value: function request(_ref2, transform) {
      var _this3 = this;

      var host = _ref2.host,
          _ref2$method = _ref2.method,
          method = _ref2$method === void 0 ? "GET" : _ref2$method,
          body = _ref2.body,
          _ref2$expectBinary = _ref2.expectBinary,
          expectBinary = _ref2$expectBinary === void 0 ? false : _ref2$expectBinary,
          _ref2$isBinary = _ref2.isBinary,
          isBinary = _ref2$isBinary === void 0 ? false : _ref2$isBinary,
          _ref2$allowDirtyRead = _ref2.allowDirtyRead,
          allowDirtyRead = _ref2$allowDirtyRead === void 0 ? false : _ref2$allowDirtyRead,
          _ref2$timeout = _ref2.timeout,
          timeout = _ref2$timeout === void 0 ? 0 : _ref2$timeout,
          headers = _ref2.headers,
          urlInfo = _objectWithoutProperties(_ref2, ["host", "method", "body", "expectBinary", "isBinary", "allowDirtyRead", "timeout", "headers"]);

      return new Promise(function (_resolve, reject) {
        var contentType = "text/plain";

        if (isBinary) {
          contentType = "application/octet-stream";
        } else if (body) {
          if (typeof body === "object") {
            body = JSON.stringify(body);
            contentType = "application/json";
          } else {
            body = String(body);
          }
        }

        var extraHeaders = _objectSpread(_objectSpread({}, _this3._headers), {}, {
          "content-type": contentType,
          "x-arango-version": String(_this3._arangoVersion)
        });

        if (_this3._transactionId) {
          extraHeaders["x-arango-trx-id"] = _this3._transactionId;
        }

        var task = {
          retries: 0,
          host: host,
          allowDirtyRead: allowDirtyRead,
          options: {
            url: _this3._buildUrl(urlInfo),
            headers: _objectSpread(_objectSpread({}, extraHeaders), headers),
            timeout: timeout,
            method: method,
            expectBinary: expectBinary,
            body: body
          },
          reject: reject,
          resolve: function resolve(res) {
            var contentType = res.headers["content-type"];
            var parsedBody = undefined;

            if (res.body.length && contentType && contentType.match(MIME_JSON)) {
              try {
                parsedBody = res.body;
                parsedBody = JSON.parse(parsedBody);
              } catch (e) {
                if (!expectBinary) {
                  if (typeof parsedBody !== "string") {
                    parsedBody = res.body.toString("utf-8");
                  }

                  e.response = res;

                  if (task.stack) {
                    e.stack += task.stack();
                  }

                  reject(e);
                  return;
                }
              }
            } else if (res.body && !expectBinary) {
              parsedBody = res.body.toString("utf-8");
            } else {
              parsedBody = res.body;
            }

            if (error_1.isArangoErrorResponse(parsedBody)) {
              res.body = parsedBody;
              var err = new error_1.ArangoError(res);

              if (task.stack) {
                err.stack += task.stack();
              }

              reject(err);
            } else if (res.statusCode && res.statusCode >= 400) {
              res.body = parsedBody;

              var _err = new error_1.HttpError(res);

              if (task.stack) {
                _err.stack += task.stack();
              }

              reject(_err);
            } else {
              if (!expectBinary) res.body = parsedBody;

              _resolve(transform ? transform(res) : res);
            }
          }
        };

        if (_this3._precaptureStackTraces) {
          if (typeof Error.captureStackTrace === "function") {
            var capture = {};
            Error.captureStackTrace(capture);

            task.stack = function () {
              return "\n".concat(capture.stack.split("\n").slice(3).join("\n"));
            };
          } else {
            var _capture = generateStackTrace();

            if (Object.prototype.hasOwnProperty.call(_capture, "stack")) {
              task.stack = function () {
                return "\n".concat(_capture.stack.split("\n").slice(4).join("\n"));
              };
            }
          }
        }

        _this3._queue.push(task);

        _this3._runQueue();
      });
    }
  }]);

  return Connection;
}();

exports.Connection = Connection;